import React from "react";
import Dropzone from "react-dropzone";

class DropZone extends React.Component {
  state = {
    files: [],
  };

  onDrop(files) {
    const onFilesDrop = this.props.onFilesDrop || null;
    if (onFilesDrop) {
      return onFilesDrop(files);
    }
  }

  render() {
    return (
      <Dropzone noClick noKeyboard onDrop={(items) => this.onDrop(items)}>
        {({ getRootProps, getInputProps }) => (
          <div
            className="dropzone"
            {...getRootProps({ className: "dropzone" })}
          >
            <input {...getInputProps()} />
            {this.props.children}
          </div>
        )}
      </Dropzone>
    );
  }

  renderx() {
    const files = this.state.files.map((file) => (
      <li key={file.name}>
        {file.name} - {file.size} bytes
      </li>
    ));

    return (
      <Dropzone noClick onDrop={this.onDrop}>
        {({ getRootProps, getInputProps }) => (
          <section className="container">
            <div {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <aside>
              <h4>Files</h4>
              <ul>{files}</ul>
            </aside>
          </section>
        )}
      </Dropzone>
    );
  }
}

export default DropZone;
